export default {

    GET_NCF_JOBS_REPORTS_REQUEST: state => {
        state.NCFJobsReportsLoading = true
    },
    GET_NCF_JOBS_REPORTS_SUCCESS: (state, data) => {
        state.NCFJobsReports = data.results
        state.NCFJobsReportsLoading = false
    },
    GET_NCF_JOBS_REPORTS_FAILURE: state => {
        state.NCFJobsReportsLoading = false
    },
    CLEAR_NCF_JOBS_REPORTS_SUMMARIES: state => {
        state.NCFJobsReport = []
    },
    SET_NCF_JOBS_REPORTS_FILTERS: (state, filters) => {
        state.NCFJobsReportsFilters = filters
    },
}